import { FC, useRef, useCallback } from "react";
import styles from "./styles/Skins.module.css";
import { ProductCard } from "@shared/ui/ProductCard";
import { useProducts } from "./model/hooks/useProducts";
import { Loader } from "@shared/ui/Loader";
import { useSelector } from "react-redux";
import { selectIsPremium, selectUserBalancePyl, selectUserRole } from "@entities/User/model/slice";

export const SkinsShopWidget: FC = () => {
  const { products, loading, error, hasMore, loadMore } = useProducts();
  const UserPyl = useSelector(selectUserBalancePyl);
  const userRole = useSelector(selectUserRole);
  const userPremium = useSelector(selectIsPremium)
  const observer = useRef<IntersectionObserver | null>(null);
  const lastProductRef = useCallback((node: HTMLDivElement | null) => {
    if (loading) return;
    
    // Отключаем предыдущий observer
    if (observer.current) observer.current.disconnect();
    
    // Создаем новый observer
    observer.current = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && hasMore) {
        console.log("Last element is visible, loading more...");
        loadMore();
      }
    }, { rootMargin: "200px" });
    
    if (node) observer.current.observe(node);
  }, [loading, hasMore, loadMore]);


  return (
    <div className={styles.container}>
      <div className={styles.grid}>
        {products.map((product, index) => (
          <div
            key={product.id}
            ref={index === products.length - 1 ? lastProductRef : null}
            className={styles.productWrapper}
          >
            <ProductCard
              id={product.id}
              name={product.name}
              price={product.price}
              image={product.image}
              isPremium={product.is_premium}
              userPremium={userPremium}
              isAvable={true}
              rarity={product.rarity}
              userMoney={Number(UserPyl ?? 0)} 
              userRole={userRole === "guest"}
            />
          </div>
        ))}
      </div>

      {loading && (
        <div className={styles.bottomLoader}>
          <Loader size="small"/>
        </div>
      )}

      {error && (
        <div className={styles.errorContainer}>
          <p className={styles.errorMessage}>{error}</p>
          <button
            onClick={() => window.location.reload()}
            className={styles.retryButton}
          >
            Повторить
          </button>
        </div>
      )}
    </div>
  );
};
